import {
  canShowScopedResource,
  type ResourceScope,
  type ResourceStatus,
} from '../scopedResource';

/** owner+scope+success 이고 라우트 projectId 와 캐시 projectId 가 일치할 때만 렌더 */
const canShowProjectScopedResource = ({
  pageOwnerAui,
  resourceOwnerAui,
  resourceScope,
  currentScope,
  status,
  resourceProjectId,
  currentProjectId,
}: {
  pageOwnerAui: string | null | undefined;
  resourceOwnerAui: string | null;
  resourceScope: ResourceScope | null;
  currentScope: ResourceScope;
  status: ResourceStatus;
  resourceProjectId: string | null;
  currentProjectId: string | null | undefined;
}): boolean =>
  !!currentProjectId &&
  !!resourceProjectId &&
  String(resourceProjectId) === String(currentProjectId) &&
  canShowScopedResource({
    pageOwnerAui,
    resourceOwnerAui,
    resourceScope,
    currentScope,
    status,
  });

export const canShowProjectDetail = canShowProjectScopedResource;

export const canShowProjectInfoList = canShowProjectScopedResource;

export const canShowProjectElementList = canShowProjectScopedResource;
